<template>
  <router-view />
</template>

<script>
export default {
  name: 'AdjustmentDrafts',
};
</script>
